import * as React from 'react';
import { ImageRef } from '../../../../commonv3/types/image';
import { ImageApis } from '../../../../commonv3/api/images';
import './blockImage.module.scss';

type Props = {
    imageRef: ImageRef;
};

export class BlockImage extends React.Component<Props> {
    render() {
        const { imageRef } = this.props;
        return (
            <div styleName="image-wrapper">
                <img src={ImageApis.getUrlFor(imageRef)} />
            </div>
        );
    }
}
